<template>
    <div class="panel">
        <h1 class="text-xl mb-4">Create a User</h1>

        <Form @submit="handleSubmit" classes="w-full">
            <TextInput label="Name" name="name" v-model="name" />
            <TextInput label="Email" name="email" type="email" v-model="email" />
            <TextInput label="Password" name="password" type="password" v-model="password" />
            <CustomSelect label="Role" name="role" :options="roles" v-model="role" />
            <button class="btn btn-tertiary mt-6" type="submit">Save</button>
        </Form>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";
import api from "../../../api/axios-api.js";
import Form from "../../Form/Form.vue";
import TextInput from "../../Form/TextInput.vue";
import CustomSelect from "../../Form/CustomSelect.vue";
import { useFormData } from "../../../composibles/formData.js";

const { errors, setFormErrors } = useFormData();
const $toast = useToast();
const router = useRouter();
const route = useRoute();

const name = ref("");
const email = ref("");
const password = ref("");
const role = ref("");
const roles = ref([]);

const fetchRoles = async () => {
    try {
        const response = await api.get("admin/roles");
        if (response.data.success) {
            roles.value = response.data.roles.map(r => ({
                label: r.name.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase()),
                value: r.id, // use numeric ID as value
            }));
            // default to Business if present
            const business = roles.value.find(r => r.label === "Business");
            if (business) role.value = business.value;
            else if (roles.value.length > 0) role.value = roles.value[0].value;
        }
    } catch (error) {
        $toast.open({
            message: error.response?.data?.message || "Failed to load roles.",
            type: "error",
        });
    }
};

const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
        const response = await api.post("admin/users", formData);

        if (response.status >= 200 && response.status < 300 && response.data.success) {
            $toast.open({ message: "User created successfully", type: "success" });
            await router.push({ name: "account/manage-users", params: { id: route.params.id } });
            return;
        }

        setFormErrors(response);
        $toast.open({
            message: response.data?.message || "Failed to create user.",
            type: "error",
        });
    } catch (error) {
        setFormErrors(error);
        $toast.open({
            message: error.response?.data?.message || error.message || "Request failed.",
            type: "error",
        });
    }
};

onMounted(fetchRoles);
</script>
